var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$store.state.loaderOpacity),expression:"this.$store.state.loaderOpacity"}],staticClass:"loarderOpacity"},[_c('Lottie',{attrs:{"options":_vm.defaultOptions,"height":50,"width":50},on:{"animCreated":_vm.handleAnimation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }